import React, {Suspense, lazy} from 'react';
import '../global-ui.css';
import {BrowserRouter, Route, Redirect, Switch} from 'react-router-dom';
import {ConfigProvider} from "antd";
import zhCN from 'antd/es/locale/zh_CN';
import Home from "./home/Home";
import Login from "./login/Login"
import Setting from "./home/set/Setting";
import Site from "./home/site/Site";
import User from "./home/user/User";
import CarModel from "./home/carModel/CarModel";
import Car from "./home/car/Car";
import Order from "./home/order/Order";
import Achievement from "./home/achievement/Achievement";
import JurisdictionManage from "./home/jurisdictionManage/JurisdictionManage";
import WorkOrderManage from "./home/workOrder/WorkOrderManage";
import TeamMembersManage from "./home/teamMembers/TeamMembersManage";
import AchievementManage from "./home/achievementManage/AchievementManage";
import SiteSettleManage from "./home/siteSettle/SiteSettleManage";
import BookkeepingManage from "./home/bookkeeping/BookkeepingManage";

// H5 移动端入口（公网 https://<PC 地址>/h5）：按需加载，手机端不下载 PC 业务代码
const H5App = lazy(() => import('../h5/H5App'));

// H5 懒加载占位：不引入 antd，保证兜底足够轻
const H5Fallback = () => (
    <div style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f4f6f7',
        color: '#7b8b87',
        fontSize: 14,
    }}>
        加载中…
    </div>
);

// 未登录直接重定向到登录页，避免先挂载后台壳再跳转，消除首屏闪顿
// 注意：必须透传 rest(history/location/match)，否则子组件拿不到路由 props 会白屏崩溃
const RequireAuth = ({component: Comp, ...rest}) => {
    const loggedIn = !!window.sessionStorage.getItem("userName");
    return loggedIn ? <Comp {...rest}/> : <Redirect to="/login"/>;
};

class App extends React.Component {
    render() {
        // 弹层挂载策略（配合 dom-align-zoom.js 补丁解决 html zoom 缩放场景下的弹层错位）：
        // - triggerNode 为空（Modal 的 getContainer 调用）：挂 body，Modal 不受 #root 影响
        // - triggerNode 在 .ant-modal-content 内：挂 .ant-modal-content（absolute 定位，
        //   在 Modal 的 stacking context 内，不会被 Modal mask 遮挡，dom-align 补丁处理缩放）
        // - 其他（列表页筛选下拉等）：挂 #root（absolute 定位，与缩放坐标系一致，
        //   dom-align 补丁通用公式 (视口坐标 - offsetParent视口坐标) / zoom 处理错位）
        return (
            <ConfigProvider locale={zhCN} getPopupContainer={(triggerNode) => {
                if (!triggerNode) return document.body;
                let node = triggerNode.parentNode;
                while (node && node !== document.body) {
                    if (node.classList && node.classList.contains('ant-modal-content')) {
                        return node;
                    }
                    node = node.parentNode;
                }
                return document.getElementById('root') || document.body;
            }}>
                <BrowserRouter basename="">
                    <Switch>
                        {/* H5 移动端：/h5 及子路由，内部路由与权限由 src/h5/H5App.js 负责 */}
                        <Route path="/h5" render={(props) => (
                            <Suspense fallback={<H5Fallback/>}>
                                <H5App {...props}/>
                            </Suspense>
                        )}/>
                        <Route exact path="/" render={(props) => <RequireAuth {...props} component={Home}/>}></Route>
                        <Route path="/home" render={(props) => <RequireAuth {...props} component={Home}/>}></Route>
                        <Route path="/login" component={Login}></Route>
                        <Route path="/setting" render={(props) => <RequireAuth {...props} component={Setting}/>}></Route>
                        <Route path="/site" render={(props) => <RequireAuth {...props} component={Site}/>}></Route>
                        <Route path="/user" render={(props) => <RequireAuth {...props} component={User}/>}></Route>
                        <Route path="/carModel" render={(props) => <RequireAuth {...props} component={CarModel}/>}></Route>
                        <Route path="/car" render={(props) => <RequireAuth {...props} component={Car}/>}></Route>
                        <Route path="/order" render={(props) => <RequireAuth {...props} component={Order}/>}></Route>
                        <Route path="/achievement" render={(props) => <RequireAuth {...props} component={Achievement}/>}></Route>
                        <Route path="/achievementManage" render={(props) => <RequireAuth {...props} component={AchievementManage}/>}></Route>
                        <Route path="/jurisdictionManage" render={(props) => <RequireAuth {...props} component={JurisdictionManage}/>}></Route>
                        <Route path="/teamMembersManage" render={(props) => <RequireAuth {...props} component={TeamMembersManage}/>}></Route>
                        <Route path="/workOrderManage" render={(props) => <RequireAuth {...props} component={WorkOrderManage}/>}></Route>
                        <Route path="/siteSettleManage" render={(props) => <RequireAuth {...props} component={SiteSettleManage}/>}></Route>
                        <Route path="/bookkeepingManage" render={(props) => <RequireAuth {...props} component={BookkeepingManage}/>}></Route>
                        <Route path="/forgetPwd" component={Login}></Route>
                        <Redirect to="/home"></Redirect>
                    </Switch>
                </BrowserRouter>
            </ConfigProvider>
        );
    }
}

export default App;
